import React, { ReactElement, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  containerClass?: string;
  grandContent?: ReactElement;
  id?: string;
}

export const ContainerBackground = ({ children, containerClass = 'background-theme', grandContent, id }: Props) => (
  <div id={id} className={`section-background ${containerClass}`}>
    <div className="container">{children}</div>
    {grandContent}
  </div>
);
